import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const HillsIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.7023 4.62222C9.8818 3.61791 8.64914 3 7.30226 3C4.85946 3 2.88652 5.01295 2.88652 7.48501C2.88652 7.74686 2.90883 8.00577 2.95258 8.25969C2.14528 8.57458 1.37948 9.0381 0.695189 9.65253C0.28425 10.0215 0.250238 10.6538 0.61922 11.0647C0.988202 11.4756 1.62045 11.5097 2.03139 11.1407C2.7167 10.5253 3.5135 10.1172 4.3469 9.91225C4.39272 9.90498 4.43845 9.89444 4.48377 9.88049C5.50819 9.65686 6.5813 9.73715 7.56588 10.114C7.5947 10.1269 7.62396 10.1384 7.65356 10.1484C8.47835 10.4807 9.23745 11.0233 9.84884 11.7717L13.5581 16.3144C13.9074 16.7421 14.5374 16.8058 14.9652 16.4564C15.393 16.1071 15.4566 15.4772 15.1073 15.0494L11.3979 10.5066C10.8539 9.84072 10.2234 9.29416 9.53758 8.86868L10.9973 7.08163C12.9114 4.73751 16.4288 4.73751 18.344 7.08169L22.5887 12.2801C22.938 12.7079 23.568 12.7715 23.9958 12.4222C24.4236 12.0729 24.4872 11.443 24.1379 11.0152L19.893 5.81653C17.5552 2.955 13.5134 2.5569 10.7023 4.62222ZM9.26725 6.03815C8.82104 5.39819 8.09604 5 7.30226 5C5.97312 5 4.88652 6.10863 4.88652 7.48501C4.88652 7.5886 4.8927 7.69119 4.90489 7.79247C5.82076 7.70214 6.74855 7.78323 7.63785 8.03291L9.26725 6.03815ZM24.3633 20.3983C24.3633 19.846 23.9156 19.3983 23.3633 19.3983H1.38629C0.834005 19.3983 0.38629 19.846 0.38629 20.3983C0.38629 20.9506 0.834005 21.3983 1.38629 21.3983H23.3633C23.9156 21.3983 24.3633 20.9506 24.3633 20.3983Z"
            />
        </svg>
    );
};
